<template>
  <div>
    <NavBar />
    <h1>課程詳情</h1>
    <CourseSessionList :course="course" />
    <StudentCourseList :course="course" />
  </div>
</template>
  
<script setup>
import NavBar from "../components/NavBar.vue";
import CourseSessionList from "../components/CourseSessionList.vue";
import StudentCourseList from "../components/StudentCourseList.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { GET_COURSE } from "../graphql/queries";
import { useQuery } from "@vue/apollo-composable";

const route = useRoute();
const course_id = parseInt(route.params.id);

const { result } = useQuery(
  GET_COURSE,
  { course_id },
  { 
    fetchPolicy: 'network-only',  // Child Course Form component could mutate the course object
  } 
);

// Computed course data
const course = computed(() => result.value?.course || {});
</script>